<template>
  <v-toolbar-items>
    <v-btn class="hidden-sm-and-down" v-for="item in menuList" flat :key="item.title" :to="item.link">{{ item.title }}
    </v-btn>

    <span class="fill-height hidden-sm-and-down">
    <user-menu></user-menu>
    </span>

    <div class="d-flex align-center">
      <reward-btn :key="$route.path"/>
    </div>
  </v-toolbar-items>
</template>

<script>
    import {mapState} from 'vuex'
    import UserMenu from "@/components/UserMenu";
    import RewardBtn from "@/components/RewardBtn";

    export default {
        name: "NavBar",
        components: {RewardBtn, UserMenu},
        computed: {
            ...mapState('layout', ['menuList'])
        }
    }
</script>

<style>
  .pointer .v-chip__content {
    cursor: pointer !important;
  }
</style>
